import images from "../../../../../../resources/images";
import {
  CREATIVE_CHART_ID,
  DAYPART_COMPILATION_CHART_ID,
  ADTYPE_CHART_ID,
  ADVISIT_BY_DAY_OF_WEEK_CHART_ID,
  AD_PERFORMANCE_CHART_ID,
  GA_CHART_ID,
  STATION_CHART_ID,
  TRAFFIC_CHANNEL_CHART_ID,
  GEO_CHART_ID,
  KEYWORD_CHART_ID,
  DEVICE_CATEGORY_CHART_ID,
  PAGE_PATH_CHART_ID
} from "../../../../../helpers/constant";
import { defaultChartSelector as DEFAULT_CHART_SELECTOR } from "../../../../../helpers/defaultInfo";
import {
  disabledText,
  reportItemType,
  deviceCategoryChartId,
  deviceCategoryId,
  deviceCategoryTableId,
  pagePathChartId,
  pagePathId,
  pagePathTableId
} from "../../../../../pages/ReportBuilder/constants";

export const comprehensiveChartsAndTablesConfig = [
  {
    id: "webAnalytics",
    title: "Web",
    children: [
      {
        id: "webAnalyticsChart",
        relativeId: "webAnalyticsTable",
        image: images.webAnalyticsChart,
        descriptionTitle: "Web Analytics",
        descriptionText: "",
        showInReport: true,
        count: [1],
        selectorId: GA_CHART_ID,
        type: reportItemType.chart,
        max: 12
      },
      {
        id: "webAnalyticsTable",
        image: images.dataTable,
        descriptionTitle: "Web Analytics- Table",
        descriptionText: "",
        showInReport: true,
        count: [1],
        selectorId: GA_CHART_ID,
        type: reportItemType.table
      },
      {
        id: "timeOfDayChart",
        image: images.timeOfDayChart,
        descriptionTitle: "Time of Day",
        descriptionText: "Chart Only",
        showInReport: true,
        count: [1],
        selectorId: ADVISIT_BY_DAY_OF_WEEK_CHART_ID,
        type: reportItemType.chart,
        max: 3
      },
      {
        id: "totalVisitsByAdChart",
        image: images.barChart,
        descriptionTitle: "Total Visits by Ads",
        descriptionText: "Chart Only",
        showInReport: true,
        count: [1],
        selectorId: AD_PERFORMANCE_CHART_ID,
        type: reportItemType.chart,
        max: 1
      }
    ]
  },
  {
    id: "daypart",
    title: "Daypart",
    children: [
      {
        id: "daypartAnalyticsChart",
        relativeId: "daypartAnalyticsTable",
        image: images.barChart,
        descriptionTitle: "Daypart",
        descriptionText: "",
        showInReport: true,
        count: [1, 2, 3, 4],
        selectorId: DAYPART_COMPILATION_CHART_ID,
        type: reportItemType.chart,
        max: 12
      },
      {
        id: "daypartAnalyticsTable",
        image: images.dataTable,
        descriptionTitle: "Daypart Analytics - Table",
        descriptionText: "",
        showInReport: true,
        count: [1, 2, 3, 4],
        selectorId: DAYPART_COMPILATION_CHART_ID,
        type: reportItemType.table
      },
      {
        id: "daypartAnalyticsChartByHour",
        relativeId: "daypartAnalyticsTable",
        image: images.barChart,
        descriptionTitle: "Daypart - by Hour",
        descriptionText: "",
        count: [],
        selectorId: DAYPART_COMPILATION_CHART_ID,
        type: reportItemType.chart,
        max: 12,
        defaultChartSelector: {
          ...DEFAULT_CHART_SELECTOR[DAYPART_COMPILATION_CHART_ID],
          timeRange: "hourly"
        }
      },
      {
        id: "daypartAnalyticsChartByDayOfWeek",
        relativeId: "daypartAnalyticsTable",
        image: images.barChart,
        descriptionTitle: "Daypart - by Day of Week",
        selectorId: DAYPART_COMPILATION_CHART_ID,
        type: reportItemType.chart,
        count: [],
        max: 12,
        defaultChartSelector: {
          ...DEFAULT_CHART_SELECTOR[DAYPART_COMPILATION_CHART_ID],
          timeRange: "byDayOfWeek"
        }
      },
      {
        id: "daypartAnalyticsChartByDate",
        relativeId: "daypartAnalyticsTable",
        image: images.barChart,
        descriptionTitle: "Daypart - by Date",
        count: [],
        selectorId: DAYPART_COMPILATION_CHART_ID,
        type: reportItemType.chart,
        max: 12,
        defaultChartSelector: {
          ...DEFAULT_CHART_SELECTOR[DAYPART_COMPILATION_CHART_ID],
          timeRange: "daily"
        }
      }
    ]
  },
  {
    id: "placement",
    title: "Placement",
    children: [
      {
        id: "placementAdTypeChart",
        image: images.barChart,
        relativeId: "placementAdTypeTable",
        descriptionTitle: "Ad Type",
        descriptionText: "",
        showInReport: true,
        count: [1],
        selectorId: ADTYPE_CHART_ID,
        type: reportItemType.chart,
        max: 3
      },
      {
        id: "placementAdTypeTable",
        image: images.dataTable,
        descriptionTitle: "Placement Ad Type - Table",
        descriptionText: "",
        showInReport: true,
        count: [1],
        selectorId: ADTYPE_CHART_ID,
        type: reportItemType.table
      },
      {
        id: "placementStationChart",
        relativeId: "placementStationTable",
        image: images.barChart,
        descriptionTitle: "Station",
        descriptionText: "",
        showInReport: true,
        count: [1],
        selectorId: STATION_CHART_ID,
        type: reportItemType.chart,
        max: 4
      },

      {
        id: "placementStationTable",
        image: images.dataTable,
        descriptionTitle: "Placement Station - Table",
        descriptionText: "",
        showInReport: true,
        count: [1],
        selectorId: STATION_CHART_ID,
        type: reportItemType.table
      }
    ]
  },
  {
    id: "creative",
    title: "Creative",
    children: [
      {
        id: "creativeChart",
        relativeId: "creativeTable",
        image: images.barChart,
        descriptionTitle: "Creative Analytics",
        descriptionText: "",
        showInReport: true,
        count: [1],
        selectorId: CREATIVE_CHART_ID,
        type: reportItemType.chart,
        max: 8
      },
      {
        id: "creativeTable",
        image: images.dataTable,
        descriptionTitle: "Creative - Table",
        descriptionText: "",
        showInReport: true,
        count: [1],
        selectorId: CREATIVE_CHART_ID,
        type: reportItemType.table
      }
    ]
  },
  {
    id: "location",
    title: "Location",
    children: [
      {
        id: "locationChart",
        relativeId: "locationTable",
        image: images.locationMap,
        disabledImage: images.disabledLocationMap,
        descriptionTitle: "Location Analytics",
        descriptionText: "",
        disabledDescriptionText: disabledText,
        showInReport: true,
        count: [1],
        selectorId: GEO_CHART_ID,
        type: reportItemType.chart,
        max: 4
      },
      {
        id: "locationTable",
        image: images.dataTable,
        descriptionTitle: "Location - Table",
        descriptionText: "",
        showInReport: true,
        count: [1],
        selectorId: GEO_CHART_ID,
        type: reportItemType.table
      }
    ]
  },
  {
    id: "trafficChannels",
    title: "Traffic Channels",
    children: [
      {
        id: "trafficChannelsChart",
        relativeId: "trafficChannelsTable",
        image: images.pieChart,
        disabledImage: images.disabledPieChart,
        descriptionTitle: "Traffic Channels",
        descriptionText: "",
        disabledDescriptionText: disabledText,
        showInReport: true,
        count: [1],
        selectorId: TRAFFIC_CHANNEL_CHART_ID,
        type: reportItemType.chart,
        max: 3
      },
      {
        id: "trafficChannelsTable",
        image: images.dataTable,
        descriptionTitle: "Traffic Channels - Table",
        descriptionText: "",
        showInReport: true,
        count: [1],
        selectorId: TRAFFIC_CHANNEL_CHART_ID,
        type: reportItemType.table
      },
      {
        id: "keywordReportTable",
        image: images.dataTable,
        disabledImage: images.dataTable,
        descriptionTitle: "Search Keyword",
        descriptionText: "",
        disabledDescriptionText: disabledText,
        showInReport: true,
        count: [1],
        selectorId: KEYWORD_CHART_ID,
        type: reportItemType.table,
        max: 2
      }
    ]
  },
  {
    id: deviceCategoryId,
    title: "Device Category",
    children: [
      {
        id: deviceCategoryChartId,
        relativeId: deviceCategoryTableId,
        image: images.pieChart,
        descriptionTitle: "Device Category",
        descriptionText: "",
        showInReport: true,
        count: [1],
        selectorId: DEVICE_CATEGORY_CHART_ID,
        type: reportItemType.chart,
        max: 1
      },
      {
        id: deviceCategoryTableId,
        image: images.dataTable,
        descriptionTitle: "Device Category Table",
        descriptionText: "",
        showInReport: true,
        count: [1],
        selectorId: DEVICE_CATEGORY_CHART_ID,
        type: reportItemType.table
      }
    ]
  },
  {
    id: pagePathId,
    title: "Page Path",
    children: [
      {
        id: pagePathChartId,
        relativeId: pagePathTableId,
        image: images.barChart,
        descriptionTitle: "Page Path",
        descriptionText: "",
        showInReport: true,
        count: [1],
        selectorId: PAGE_PATH_CHART_ID,
        type: reportItemType.chart,
        max: 1
      },
      {
        id: pagePathTableId,
        image: images.dataTable,
        descriptionTitle: "Page Path Table",
        descriptionText: "",
        showInReport: true,
        count: [1],
        selectorId: PAGE_PATH_CHART_ID,
        type: reportItemType.table
      }
    ]
  }
];

export const comprehensiveChartSelector = {
  [GA_CHART_ID]: [],
  [ADVISIT_BY_DAY_OF_WEEK_CHART_ID]: [],
  [AD_PERFORMANCE_CHART_ID]: [],
  [DAYPART_COMPILATION_CHART_ID]: [],
  [ADTYPE_CHART_ID]: [],
  [STATION_CHART_ID]: [],
  [CREATIVE_CHART_ID]: [],
  [GEO_CHART_ID]: [],
  [TRAFFIC_CHANNEL_CHART_ID]: [],
  [KEYWORD_CHART_ID]: [],
  [DEVICE_CATEGORY_CHART_ID]: [],
  [PAGE_PATH_CHART_ID]: [],
};

export const chartSelector = comprehensiveChartsAndTablesConfig.reduce((acc, item) => {
  item.children.forEach(child => {
    const { selectorId, type, defaultChartSelector } = child;
    const addedChartSelector = defaultChartSelector
      ? defaultChartSelector
      : DEFAULT_CHART_SELECTOR[selectorId];    
    type === reportItemType.chart &&
      acc[selectorId].unshift(addedChartSelector);
  });
  return acc;
}, comprehensiveChartSelector);